export default __webpack_public_path__ + "static/media/1.Water-Treatment-Chemical.5722db41.jpg";